import { motion, type MotionProps } from "framer-motion";
import type React from "react";

type AnimationVariant = "fade" | "blink";

interface AnimatedTextProps
  extends Omit<MotionProps, "animate" | "initial" | "transition"> {
  children: React.ReactNode;
  variant?: AnimationVariant;
  className?: string;
  duration?: number;
}

export const AnimatedText: React.FC<AnimatedTextProps> = ({
  children,
  variant = "fade",
  className = "",
  duration = 2,
  ...rest
}) => {
  const animations: Record<
    AnimationVariant,
    {
      initial?: MotionProps["initial"];
      animate: MotionProps["animate"];
      transition: MotionProps["transition"];
    }
  > = {
    fade: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration, ease: "easeInOut" },
    },
    blink: {
      animate: { opacity: [1, 0.5, 1] },
      transition: { duration, repeat: Infinity, ease: "easeInOut" },
    },
  };

  const { initial, animate, transition } = animations[variant];

  return (
    <motion.div
      animate={animate}
      className={`text-gray-500 text-sm cursor-default select-none ${className}`}
      initial={initial}
      transition={transition}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
